if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.customization = this.querySelector('[data-product-customization]');
      this.bindCustomization();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const customizationPayload = this.getCustomizationPayload(formData);

      if (customizationPayload.error) {
        this.handleErrorMessage(customizationPayload.error);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }

      if (customizationPayload.body) {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(customizationPayload.body);
      } else {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.normalizeCartNotificationResponse(response);
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        }
      }

    bindCustomization() {
      if (!this.customization) return;

      const toggle = this.customization.querySelector('[data-customization-toggle]');
      const field = this.customization.querySelector('[data-customization-field]');
      const nameInput = this.customization.querySelector('[data-customization-name]');
      const customizationCheckout = this.querySelector('[data-customization-checkout]');

      const sync = () => {
        const checked = toggle.checked;
        field.hidden = !checked;
        nameInput.disabled = !checked;
        if (!checked) nameInput.value = '';
      };

      nameInput.addEventListener('input', () => {
        nameInput.value = nameInput.value.toUpperCase().slice(0, 4);
      });

      toggle.addEventListener('change', sync);
      if (customizationCheckout) customizationCheckout.addEventListener('click', this.onCustomizationCheckout.bind(this));
      sync();
    }

    onCustomizationCheckout(evt) {
      evt.preventDefault();

      const checkoutButton = evt.currentTarget;
      if (checkoutButton.classList.contains('loading')) return;

      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
      this.handleErrorMessage();

      const formData = new FormData(this.form);
      const customizationPayload = this.getCustomizationPayload(formData);

      if (customizationPayload.error) {
        this.handleErrorMessage(customizationPayload.error);
        checkoutButton.classList.remove('loading');
        checkoutButton.removeAttribute('aria-disabled');
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(customizationPayload.body || this.getDirectCheckoutPayload(formData));

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error(error);
          this.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(() => {
          checkoutButton.classList.remove('loading');
          checkoutButton.removeAttribute('aria-disabled');
        });
    }

    getCustomizationPayload(formData) {
      if (!this.customization) return {};

      const toggle = this.customization.querySelector('[data-customization-toggle]');
      if (!toggle || !toggle.checked) return {};

      const nameInput = this.customization.querySelector('[data-customization-name]');
      const nameToPrint = (nameInput.value || '').trim().toUpperCase().slice(0, 4);
      const feeVariantId = this.customization.dataset.feeVariantId;
      const productTitle = this.customization.dataset.productTitle || document.title;
      const customizationCharge = this.customization.dataset.customizationCharge;
      const quantity = Number(formData.get('quantity') || 1);
      const productVariantId = formData.get('id');

      if (!nameToPrint) return { error: 'Please enter the name to print.' };
      if (!feeVariantId) return { error: 'Customization charge product is not set up yet.' };

      return {
        body: {
          items: [
            {
              id: productVariantId,
              quantity,
              properties: {
                'Name Customization': 'Yes',
                'Name to Print': nameToPrint,
                'Customization Charge': `Rs. ${customizationCharge} per pc`
              }
            },
            {
              id: feeVariantId,
              quantity,
              properties: {
                '_customization_fee': 'true',
                'For product': productTitle,
                'Name to Print': nameToPrint
              }
            }
          ],
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        }
      };
    }

    normalizeCartNotificationResponse(response) {
      if (!response || response.id || !Array.isArray(response.items) || !response.items.length) return response;
      response.id = response.items[0].id;
      return response;
    }

    getDirectCheckoutPayload(formData) {
      return {
        items: [
          {
            id: formData.get('id'),
            quantity: Number(formData.get('quantity') || 1)
          }
        ]
      };
    }
  });
}
